<template>
  <div id="zt8631">
    <div id="z1">
      <div>ZT8631</div>
      <label>即开型彩票销售终端</label>
    </div>
    <div id="z2">
      <label>ZT8631桌面彩票终端是一款基于安卓系统的智能终端，适用于销售福彩/体彩的即开型彩票，具有外观精美，牢固耐用，易布放的特点。</label>
    </div>
    <div id="z3">
      <div>灵动扫码  拒绝伪装</div>
      <label>屏幕支持动态二维码，拒绝伪造，提高支付安全性。</label>
      <div>满腹经纶  有容乃大</div>
      <label>可支持各种尺寸的即开票，包括4寸、4寸、6寸、8寸等。</label>
    </div>
    <pdspecs :data="spdata"></pdspecs>
  </div>
</template>

<script>
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      spdata: {
        file: 'ZT8631',
        data: [
          {label: _this.$t('lang.cpu'), desc: [_this.$t('lang.armq11cpu'),_this.$t('lang.cpu32bsafe')],pic: 'cpu.png'},
          {label: _this.$t('lang.memory'), desc: ['1GB RAM+8GB ROM',_this.$t('lang.ram2p16opt'),_this.$t('lang.sdexpmax32')],pic: 'ram.png'},
          {label: _this.$t('lang.os'), desc: ['Android 5.1',_this.$t('lang.ztsafeos')], pic: 'sys.png'},
          {label: '屏幕', desc: ['3.5英寸480×320','支持动态二维码显示'], pic: 'disp.png'},
          {label: '即开出票模块', desc: ['支持5元、10元、20元面值', '走纸速度：150mm/秒','自动撕纸器： 全切'], pic: 'tick.png'},
          {label: _this.$t('lang.mobinet'), desc: [_this.$t('lang.sptnettype')], pic: 'mobi.png'},
          {label: 'WIFI', desc: [_this.$t('lang.spt8021124')], pic: 'wifi.png'},
          {label: _this.$t('lang.blueto'), desc: [_this.$t('lang.sptblt40'),_this.$t('lang.sptble')], pic: 'blt.png'},
          {label: _this.$t('lang.location'), desc: [_this.$t('lang.ingpsbdgln'),_this.$t('lang.sptlbsfunc'),_this.$t('lang.sptagps')], pic: 'lbs.png'},
          {label: _this.$t('lang.speaker'), desc: [_this.$t('lang.inspk05w'),'声压82dB±3dB，支持音频播放'], pic: 'speaker.png'},
          {label: _this.$t('lang.port'), desc: ['Micro USBx1','USB 2.0 HSx1'], pic: 'port.png'},
          {label: _this.$t('lang.adapter'), desc: [_this.$t('lang.inputac100240'),'输出： DC 24V/3A'], pic: 'char.png'},
          {label: _this.$t('lang.size'), desc: ['375mm×205mm×317mm'], pic: 'size.png'},
          {label: _this.$t('lang.suitenv'), desc: [_this.$t('lang.wktemp050')], pic: 'env.png'}
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt8631 {
  background: white;
  margin-top: -.93rem;
}
#z1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8631/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.42rem;
  color: white;
}
#z1 div {
  margin-top: 2.97rem;
  font-size: .6rem;
  font-weight: bold;
}
#z1 label {
  display: block;
  font-weight: 400;
  margin-top: .07rem;
  font-size: .6rem;
}

#z2 {
  height: 1.78rem;
  background: #8D97A2  ;
  text-align: center;
}
#z2 label {
  display: inline-block;
  width: 7.32rem;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: .45rem;
  line-height: .48rem;
}

#z3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8631/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 12.34rem;
  color: white;
}
#z3 div {
  margin: 0 0 .05rem 0;
  font-size: .35rem;
  font-weight: bold;
}
#z3 div:nth-child(1) {
  margin-top: 2.6rem;
}
#z3 div:nth-child(3) {
  margin-top: 1.15rem;
}
#z3 label {
  margin-left: .05rem;
  display: block;
  font-size: .18rem;
  font-weight: 400;
  color: #F4F4F4 ;
}


</style>
